import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Menu from "../ui/Menu";
import ReconciliationController from "../controllers/ReconciliationController";
import { ROUTES } from "../utils/Routes";
import { createScreen } from "../hooks/createScreen";
import { kbdEvent, runEvent } from "../utils/Utils";

export default function InventoryExtra(props) {

    const { controller = "", callback = () => { }, route = "", signal = {} } = props;

    const menu = [
        { text: "Inventory quantity O/H reconciliation", key: KBD.R, option: "R", action: () => drawReconciliation() },
        { text: "Promotional sale items (build/review)", key: KBD.P, option: "P", action: () => callback("P") },
        { text: "Recalculate Cost of each ISBN in Inventory", key: KBD.F, option: "F", action: () => callback("F") },
        { text: "Rebuild this Title's Rcvd/Sold/TtlRcv/TtlRtn/1stRcvd fields", key: KBD.A, option: "A", action: () => callback("A") },
        { text: "Standardize author punctuation", key: KBD.C, option: "C", action: () => callback("C") },
        { text: "Update Carton Qtys from Titlelink", key: KBD.Q, option: "Q", action: () => callback("Q") },
        { text: "Print book labels for all inventory On Hand", key: KBD.D, option: "D", action: () => callback("D") },
        { text: "Bulk-purchase Profit Analysis (remainders/hurts)", key: KBD.B, option: "B", action: () => callback("B") },
        { text: "Textbook Management", key: KBD.T, option: "T", action: () => callback("T") },
    ]

    const [selected, setSelected] = useState("R");

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(selected) } },
            {
                key: KBD.ENTER, action: (e) => {
                    {
                        if (selected === "R") {
                            drawReconciliation();
                        } else {
                            callback(selected)
                        }
                    }
                }
            },
        ];
        const cleanup = listen(controller, route, actions.concat(menu));
        return cleanup;
    }, [selected]);



    const drawReconciliation = () => {
        runEvent("drawReconciliation");
    }


    return (
        <div style={{ "width": "550px" }}>
            <div className="shim" /><div className="shim" />
            <Menu controller={controller} callback={(e) => callback(e.sort)} bordered keyName="option" show_keys setSelected={setSelected} selected={selected} menu={menu} route={route} />
        </div>
    )


}